import type { schemaType as cottagesDetailSchemaType } from '~~/modules/api/rurality/v3/cottages/detail/schema'
import type { schemaType as ownersDetailSchemaType } from '~~/modules/api/rurality/v3/owners/detail/schema'
import type { schemaType as cottagesRecommendedSchemaType } from '~~/modules/api/rurality/v3/cottages/recommended-by-cottage/detail/schema'
import type { schemaType as seoLinksSchemaType } from '~~/modules/api/rurality/v3/cottages/seo-links/schema'
import type { schemaType as reviewsSchemaType } from '~~/modules/api/rurality/v3/cottage-reviews/cottage/detail/schema'
import type { schemaType as dealsSchemaType } from '~~/modules/api/rurality/v3/cottage-deals/cottage/detail/schema'
import type { CottagePage } from '~~/modules/views/cottage/entities/CottagePage'
import { useToCottagePageRecommended } from '~~/modules/views/cottage/composables/transformers/useToCottagePageRecommended'

export const useToCottagePage = () => {
  const fromRurality = (params: {
    cottagesDetail: cottagesDetailSchemaType
    ownersDetail: ownersDetailSchemaType
    cottagesRecommended: cottagesRecommendedSchemaType | null
    seoLinks: seoLinksSchemaType | null
    reviews: reviewsSchemaType | null
    deals: dealsSchemaType | null
  }): CottagePage | null => {
    const parseCottagesPage = function (
      cottagesDetail: cottagesDetailSchemaType,
    ): cottagesDetailSchemaType {
      if (params.cottagesDetail.salesService.isAllowedToShowVideos) {
        return cottagesDetail
      } else {
        const filteredMedia = cottagesDetail.media.filter(item => {
          return item.type === 'PHOTO'
        })

        const parsedCottagesPage: cottagesDetailSchemaType = {
          ...cottagesDetail,
          media: filteredMedia,
        }

        return parsedCottagesPage
      }
    }

    let cottagePage: CottagePage | null = null

    let recommended = null

    if (params.cottagesRecommended) {
      recommended = useToCottagePageRecommended().fromRurality({
        cottagesRecommended: params.cottagesRecommended,
      })
    }

    const parsedCottagePage = parseCottagesPage(params.cottagesDetail)

    cottagePage = {
      ...parsedCottagePage,
      owner: params.ownersDetail,
      recommended: recommended,
      seoLinks: params.seoLinks,
      reviews: params.reviews,
      deals: params.deals,
    }

    return cottagePage
  }

  return { fromRurality }
}
